<template>
  <div class="header__wrap">
    <!-- allows you to click outside of a sub-manu to close it -->
    <div
      class="header__sub-nav-escape"
      @click="closeAllMenus"
      v-if="anyMenuOpen"
    ></div>
    <header
      class="header"
      :class="{
        'header--expanded': menuOpen.main,
        'header--non-auth': !loggedIn,
      }"
    >
      <div class="header__content header__pad">
        <h1 class="header__logo">
          <component
            :is="loggedIn ? 'router-link' : 'a'"
            :to="{ name: 'dashboard overview' }"
            href="/"
          >
            <Logo class="layout--block layout--full-width" />
            <span class="sr-only">Motion Mail</span>
          </component>
        </h1>
        <button
          class="header__toggle"
          @click="toggleMenu('main')"
          :aria-expanded="menuOpen.main"
          aria-controls="mainNav"
        >
          <div
            class="header__toggle-icon"
            :class="{
              'header__toggle-icon--close': menuOpen.main,
            }"
          ></div>
        </button>

        <nav
          id="mainNav"
          class="header__nav"
          :class="{ 'header__nav--expanded': menuOpen.main }"
          aria-label="Primary menu"
        >
          <ul v-if="loggedIn" class="header__nav-list">
            <li class="header__nav-item" @click="closeAllMenus">
              <router-link
                :to="{ name: 'dashboard overview' }"
                :class="{
                  'header__nav-item-link--active':
                    $route.name === 'dashboard' ||
                    $route.name === 'dashboard overview',
                }"
                class="header__nav-item-link"
                >Dashboard</router-link
              >
            </li>
            <li class="header__nav-item" @click="closeAllMenus">
              <component
                :is="isAccountActive ? 'router-link' : 'span'"
                :to="{ name: 'create a timer' }"
                :class="{
                  'header__nav-item-link--active':
                    $route.name === 'create a timer',
                  'header__nav-item-link--disabled':
                    !isAccountActive,
                }"
                class="header__nav-item-link"
                >Create New Timer</component
              >
            </li>
            <li class="header__nav-item" @click="closeAllMenus">
              <router-link
                :to="{ name: 'change plan' }"
                :class="{
                  'header__nav-item-link--active':
                    $route.name === 'change plan',
                }"
                class="header__nav-item-link"
                >Plans</router-link
              >
            </li>
            <li class="header__nav-item" @click="closeAllMenus">
              <a
                class="header__nav-item-link"
                href="//motionmail.freshdesk.com/support/home"
                target="_blank"
                >Help</a
              >
            </li>
            <li class="header__nav-item-link header__nav-item--end">
              <button
                type="button"
                @click="toggleMenu('myAccount')"
                class="header__sub-nav-button"
                :aria-expanded="menuOpen.myAccount"
                aria-controls="myAccountMenu"
              >
                <IconUserProfile
                  class="header__nav-icon layout--margin-right-xs layout--hide-tablet-down"
                />
                {{ data.userDto.credentials_Email }}
                <IconChevron
                  class="layout--margin-left-xs header__nav-icon header__nav-icon--small"
                  :class="{ 'header__nav-icon--turned': menuOpen.myAccount }"
                />
              </button>
              <ul
                id="myAccountMenu"
                class="header__sub-nav-list"
                :hidden="!menuOpen.myAccount"
              >
                <li class="header__sub-nav-item" @click="closeAllMenus">
                  <router-link
                    :to="{ name: 'overview' }"
                    :class="{
                      'header__nav-item-link--active':
                        $route.name === 'account' || $route.name === 'overview',
                    }"
                    class="header__nav-item-link"
                  >
                    Overview</router-link
                  >
                </li>
                <li class="header__sub-nav-item" @click="closeAllMenus">
                  <router-link
                    :to="{ name: 'plan and billing' }"
                    class="header__nav-item-link"
                    :class="{
                      'header__nav-item-link--active':
                        $route.name === 'plan and billing',
                    }"
                    >Plan and Billing</router-link
                  >
                </li>
                <li class="header__sub-nav-item" @click="closeAllMenus">
                  <router-link
                    :to="{ name: 'advanced settings' }"
                    class="header__nav-item-link"
                    :class="{
                      'header__nav-item-link--active':
                        $route.name === 'advanced settings',
                    }"
                    >Timer Settings</router-link
                  >
                </li>
                <li class="header__sub-nav-item layout--hide-tablet-down">
                  <button
                    type="button"
                    class="header__nav-item-link"
                    @click="logOut"
                  >
                    Logout
                  </button>
                </li>
              </ul>
            </li>
            <li
              class="header__nav-item header__nav-item--short layout--hide-tablet-up layout--margin-top-md"
            >
              <button type="button" class="button button--wide">Upgrade</button>
            </li>
            <li
              class="header__nav-item header__nav-item--short layout--hide-tablet-up"
            >
              <button
                type="button"
                class="button button--secondary button--wide"
                @click="logOut"
              >
                Logout
              </button>
            </li>
          </ul>

          <ul v-else class="header__nav-list header__nav-list--non-auth">
            <li class="header__nav-item">
              <a href="/#plans" class="header__nav-item-link">Plans</a>
            </li>
            <li class="header__nav-item">
              <a
                href="//motionmail.freshdesk.com/support/home"
                class="header__nav-item-link"
                >Support</a
              >
            </li>
            <li class="header__nav-item header__nav-item--btn">
              <router-link
                :to="{ name: 'login' }"
                class="button button--secondary button--small weight--bold"
              >
                Login</router-link
              >
            </li>
            <li class="header__nav-item header__nav-item--btn">
              <router-link
                :to="{ name: 'register' }"
                class="button button--tertiary button--small"
                >Sign Up</router-link
              >
            </li>
          </ul>
        </nav>
      </div>
    </header>
  </div>
</template>

<script>
import { RouterLink } from "vue-router";
import { mapGetters } from "vuex";

import { mapActions } from "vuex";

import Logo from "../assets/icons/motionmail-logo-2021.svg";
import Divider from "../components/Divider";
import IconChevron from "../assets/icons/icon-chevron.svg";
import IconUserProfile from "../assets/icons/iconUserProfile.svg";

export default {
  name: "Header",
  components: {
    Logo,
    Divider,
    IconChevron,
    IconUserProfile,
  },
  props: {
    loggedIn: Boolean,
  },
  data() {
    return {
      menuOpen: {
        main: false,
        myAccount: false,
      },
    };
  },
  methods: {
    ...mapActions("session", ["logOut"]),
    // toggles a specific menu on or off
    toggleMenu: function(menuName) {
      this.menuOpen[menuName] = !this.menuOpen[menuName];
    },
    // closes all menus
    closeAllMenus: function() {
      const keys = Object.keys(this.menuOpen);
      keys.forEach(key => (this.menuOpen[key] = false));
    },
  },
  computed: {
    ...mapGetters("account", ["data", "account", "isAccountActive"]),
    loginScreen: function() {
      return (
        this.$route.name === "login" || this.$route.name === "forgot password"
      );
    },
    anyMenuOpen: function() {
      const keys = Object.keys(this.menuOpen);
      return keys.some(key => this.menuOpen[key] === true);
    },
  },
};
</script>

<style lang="scss">
@import "../styles/pages/_header.scss";
// @import "../styles/components/_hamburger.scss";
</style>
